import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const WHATSAPP_URL = "https://api.whatsapp.com/send/?phone=%2B18438332152&text&type=phone_number&app_absent=0";

const WhatsAppButton = () => {
  const { t } = useTranslation();
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("whatsappBtn.label") as string}
      className="fixed bottom-6 right-6 rtl:right-auto rtl:left-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-primary/40 animate-ping opacity-60 group-hover:opacity-0 transition-opacity" />
      <span className="relative w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30 flex items-center justify-center hover:scale-110 transition-transform duration-300">
        <MessageCircle className="h-6 w-6" strokeWidth={1.8} />
      </span>
      <span className="absolute right-full rtl:right-auto rtl:left-full mr-3 rtl:mr-0 rtl:ml-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-foreground text-background text-xs font-medium px-3 py-1.5 rounded-md opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        {t("whatsappBtn.tooltip")}
      </span>
    </a>
  );
};

export default WhatsAppButton;
